import script from "./SupportTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportTicket.vue?vue&type=script&setup=true&lang=js"

import "./SupportTicket.vue?vue&type=style&index=0&id=79121fa2&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79121fa2"]])

export default __exports__